webpackJsonp([6],{

/***/ "8wY1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _initialiseProps;

var _Message = __webpack_require__("mzOA");

var _Message2 = _interopRequireDefault(_Message);

var _Modal = __webpack_require__("/MvA");

var _Modal2 = _interopRequireDefault(_Modal);

var _util = __webpack_require__("oFuF");

var _ajax = __webpack_require__("Z1y9");

var _ajax2 = _interopRequireDefault(_ajax);

var _UserReducer = __webpack_require__("i0Fb");

var _actionTypes = __webpack_require__("4HHy");

var _UserAction = __webpack_require__("XaZM");

var _NestLoading = __webpack_require__("66rn");

var _NestLoading2 = _interopRequireDefault(_NestLoading);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _VerifyModal = __webpack_require__("GQYJ");

var _VerifyModal2 = _interopRequireDefault(_VerifyModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VerifyModal = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    userOtpChannel: (0, _UserReducer.getUserOtpChannelState)(state)
  };
}, function (dispatch) {
  return {
    getUserOtpChannel: function getUserOtpChannel() {
      return dispatch((0, _UserAction.getUserOtpChannel)());
    }
  };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(VerifyModal, _Component);

  function VerifyModal(props) {
    (0, _classCallCheck3.default)(this, VerifyModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (VerifyModal.__proto__ || (0, _getPrototypeOf2.default)(VerifyModal)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      error: '',
      confirming: false, // 正在验证验证码
      sending: false, // 正在请求发送验证吗
      curChannel: _this.getCurChannel(),
      curSecond: 0, // 倒计时秒数
      isResendCaptcha: false // 是否是重发验证码
    };
    return _this;
  }

  (0, _createClass3.default)(VerifyModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var visible = nextProps.visible;

      var otpCapstatus = nextProps.userOtpChannel.get('status');
      if (otpCapstatus !== _actionTypes.User.GET_USER_OTP_CHANNEL_SUCCESS) {
        nextProps.getUserOtpChannel();
      }
      this.setState({
        curChannel: this.getCurChannel(nextProps)
      });
      // 重新显示
      if (visible && !this.props.visible) {
        this.setState({
          isResendCaptcha: false
        });
        if (this.inputRef) {
          this.inputRef.value = ''; // 清空input
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          error = _state.error,
          curChannel = _state.curChannel,
          curSecond = _state.curSecond,
          isResendCaptcha = _state.isResendCaptcha,
          confirming = _state.confirming;
      var _props = this.props,
          onModalCancelClick = _props.onModalCancelClick,
          visible = _props.visible;

      var userOtpChannelData = this.getOtpChannelData();
      var sendBtnClass = (0, _classnames2.default)(_VerifyModal2.default['btn-in-resend'], (0, _defineProperty3.default)({}, _VerifyModal2.default['disable'], !!curSecond));
      var captchaBtnTip = 'verifymodal.send-captcha';
      if (curSecond) {
        captchaBtnTip = 'verifymodal.sending-captcha';
      } else if (isResendCaptcha) {
        captchaBtnTip = 'verifymodal.resend-captcha';
      }

      return _react2.default.createElement(
        _Modal2.default,
        {
          width: 397,
          visible: visible,
          showFooter: false,
          maskClassName: _VerifyModal2.default['mask'],
          closable: true,
          isMiddle: true,
          title: _reactIntlUniversal2.default.get('verifymodal.title'),
          onCancel: onModalCancelClick
        },
        _react2.default.createElement(
          'div',
          { className: _VerifyModal2.default['modal-body'] },
          _react2.default.createElement(
            'p',
            { className: _VerifyModal2.default['des'] },
            _reactIntlUniversal2.default.get('verifymodal.des', { minute: 10 })
          ),
          _react2.default.createElement(
            'p',
            { className: _VerifyModal2.default['chanel-des'] },
            curChannel && _reactIntlUniversal2.default.get('verifymodal.' + curChannel + '-prefix'),
            _react2.default.createElement(
              'span',
              null,
              userOtpChannelData && userOtpChannelData.get(curChannel)
            ),
            _reactIntlUniversal2.default.get('verifymodal.verify')
          ),
          _react2.default.createElement(
            'div',
            { className: _VerifyModal2.default['input-prepend'] },
            _react2.default.createElement('i', { className: 'fa fa-shield' }),
            _react2.default.createElement('input', {
              type: 'text',
              name: 'security',
              placeholder: _reactIntlUniversal2.default.get('verifymodal.captcha'),
              ref: function ref(v) {
                _this2.inputRef = v;
              }
            }),
            _react2.default.createElement(
              'a',
              {
                className: sendBtnClass,
                onClick: this.sendCaptcha
              },
              _reactIntlUniversal2.default.get(captchaBtnTip, { num: curSecond })
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: _VerifyModal2.default['confirm-btn'],
              onClick: this.onConfirmBtnClick
            },
            confirming ? _reactIntlUniversal2.default.get('verifymodal.confirming') : _reactIntlUniversal2.default.get('verifymodal.confirm')
          ),
          curChannel === 'sms' && userOtpChannelData.get('email') && _react2.default.createElement(
            'p',
            {
              className: _VerifyModal2.default['switch-btn'],
              onClick: this.switchBtnClick,
              'data-chanel': 'email'
            },
            _reactIntlUniversal2.default.get('verifymodal.by-email')
          ),
          curChannel === 'email' && userOtpChannelData.get('sms') && _react2.default.createElement(
            'p',
            {
              className: _VerifyModal2.default['switch-btn'],
              onClick: this.switchBtnClick,
              'data-chanel': 'sms'
            },
            _reactIntlUniversal2.default.get('verifymodal.by-phone')
          ),
          !userOtpChannelData && _react2.default.createElement(_NestLoading2.default, { loading: true, tip: _reactIntlUniversal2.default.get('verifymodal.loading') })
        )
      );
    }
  }]);
  return VerifyModal;
}(_react.Component), _class2.defaultProps = {
  onModalCancelClick: _util.noop,
  onModalConfirmBtnClick: _util.noop
}, _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.getCurChannel = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3.props;

    var userOtpChannelData = _this3.getOtpChannelData(props);
    if (!userOtpChannelData) {
      return '';
    }
    // 优先sms
    if (userOtpChannelData.get('sms')) {
      return 'sms';
    }
    if (userOtpChannelData.get('email')) {
      return 'email';
    }

    return '';
  };

  this.onConfirmBtnClick = function () {
    var confirming = _this3.state.confirming;
    var onModalConfirmBtnClick = _this3.props.onModalConfirmBtnClick;

    var captcha = (_this3.inputRef.value || '').trim();
    if (captcha && !confirming) {
      _this3.setState({
        confirming: true
      });
      _ajax2.default.verifyCaptcha({ code: captcha }).then(function () {
        _this3.setState({
          confirming: false
        });
        onModalConfirmBtnClick();
      }).catch(function () {
        _Message2.default.error(_reactIntlUniversal2.default.get('verifymodal.verify-captcha-error'));
        _this3.setState({
          confirming: false
        });
      });
    } else {
      _Message2.default.error(_reactIntlUniversal2.default.get('verifymodal.empty-captcha'));
    }
  };

  this.switchBtnClick = function (e) {
    var chanel = e.target.getAttribute('data-chanel');
    _this3.setState({
      curChannel: chanel
    });
  };

  this.startConutDown = function (total) {
    clearInterval(_this3.captchaTimer);
    _this3.setState({
      curSecond: total
    });
    _this3.captchaTimer = setInterval(function () {
      var _state2 = _this3.state,
          curSecond = _state2.curSecond,
          isResendCaptcha = _state2.isResendCaptcha;

      curSecond -= 1;
      if (curSecond <= 0) {
        clearInterval(_this3.captchaTimer);
        curSecond = 0;
        isResendCaptcha = true;
      }
      _this3.setState({ curSecond: curSecond, isResendCaptcha: isResendCaptcha });
    }, 1000);
  };

  this.sendCaptcha = function (e) {
    var _state3 = _this3.state,
        curChannel = _state3.curChannel,
        curSecond = _state3.curSecond,
        sending = _state3.sending;

    if (curSecond || sending) {
      return;
    }
    _this3.setState({ sending: true });
    _ajax2.default.sendCaptcha({ channel: curChannel }).then(function () {
      _this3.startConutDown(60);
      _this3.setState({ sending: false });
    }).catch(function () {
      _Message2.default.error(_reactIntlUniversal2.default.get('verifymodal.send-captcha-error'));
      _this3.setState({ sending: false });
    });
  };

  this.getOtpChannelData = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3.props;

    return props.userOtpChannel.get('data');
  };
}, _temp)) || _class);
exports.default = VerifyModal;

/***/ }),

/***/ "AK2N":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("yqWn");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./EmptyContent.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./EmptyContent.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "EAWY":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "._25lUc{height:100%}._25lUc ._2pnkW{position:fixed;top:0;left:0;width:300px;height:100%;border-right:1px solid #d9d9d9;overflow-y:auto}body.reader-night-mode ._25lUc ._2pnkW{border-color:#2e2e2e;background-color:#3d3d3d}._25lUc ._2pnkW ._1T8aX{padding:5px 10px;margin:0;border-bottom:1px solid #d9d9d9;font-size:20px;font-weight:400}body.reader-night-mode ._25lUc ._2pnkW ._1T8aX{color:#b3b3b3;border-color:#2e2e2e}._25lUc ._2pnkW ul li{border-left:3px solid transparent}._25lUc ._2pnkW ul li:hover{background-color:#e6e6e6}body.reader-night-mode ._25lUc ._2pnkW ul li:hover{background-color:#2e2e2e}._25lUc ._2pnkW ul li.fom-W{background-color:#f2f2f2;border-color:#ec7259}body.reader-night-mode ._25lUc ._2pnkW ul li.fom-W{background-color:#2e2e2e}._25lUc ._2pnkW ul li a{display:block;position:relative;padding:12px 10px;font-size:12px;line-height:20px;border-bottom:1px solid #d9d9d9}body.reader-night-mode ._25lUc ._2pnkW ul li a{border-color:#2e2e2e}._25lUc ._2pnkW ul li a h5{width:180px;margin:0;color:#333;font-weight:400;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}body.reader-night-mode ._25lUc ._2pnkW ul li a h5{color:#b3b3b3}._25lUc ._2pnkW ul li a span{position:absolute;top:12px;right:10px;display:block;color:#b3b3b3}._25lUc ._25mn_{height:100%;margin:0 0 0 300px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}body.reader-night-mode ._25lUc ._25mn_{background-color:#3d3d3d}._25lUc ._25mn_ .QBGUR{width:100%;height:82px;padding-top:20px;padding-bottom:20px;background:#e6e6e6}body.reader-night-mode ._25lUc ._25mn_ .QBGUR{background-color:#2e2e2e}._25lUc ._25mn_ .QBGUR h3{position:relative;width:740px;display:inline-block;left:50%;margin:auto auto auto -370px;font-size:24.5px;color:#333;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}body.reader-night-mode ._25lUc ._25mn_ .QBGUR h3{color:#b3b3b3}._25lUc ._25mn_ .QBGUR ._1i-No{position:relative;display:inline-block;right:50%;margin-right:-390px;margin-top:-14px;font-size:40px;font-weight:300;float:right;color:#595959;cursor:pointer}body.reader-night-mode ._25lUc ._25mn_ .QBGUR ._1i-No{color:#b3b3b3}._25lUc ._25mn_ .QBGUR ._1i-No::-moz-selection{background:transparent;color:#595959}._25lUc ._25mn_ .QBGUR ._1i-No::selection{background:transparent;color:#595959}._25lUc ._25mn_ ._1V2C_{overflow-y:auto;position:relative;height:100%;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}._25lUc ._25mn_ ._1V2C_ ._2bvRp{width:800px;margin:auto;padding:30px 30px 50px}._25lUc ._25mn_ ._2X1Nj{padding:8px 0;text-align:center}._25lUc ._25mn_ ._2X1Nj ._1XG6y{cursor:pointer;display:inline-block;padding:9px 32px 7px;margin:0 10px;font-size:16px;color:#fff;border-radius:4px}._25lUc ._25mn_ ._2X1Nj ._3Ib_G{border-color:#42c02e;background:#42c02e}._25lUc ._25mn_ ._2X1Nj ._2_Gwf{border-color:#ec7259;background:#ec7259}", ""]);

// exports
exports.locals = {
	"recycle-page": "_25lUc",
	"recycle-list-wrap": "_2pnkW",
	"title": "_1T8aX",
	"active": "fom-W",
	"content-wrap": "_25mn_",
	"title-wrap": "QBGUR",
	"close": "_1i-No",
	"content-view-wrap": "_1V2C_",
	"content-view": "_2bvRp",
	"footer": "_2X1Nj",
	"btn": "_1XG6y",
	"btn-recovery": "_3Ib_G",
	"btn-del": "_2_Gwf"
};

/***/ }),

/***/ "GQYJ":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("rzIX");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./VerifyModal.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./VerifyModal.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "JtiA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _row = __webpack_require__("0b0c");

var _row2 = _interopRequireDefault(_row);

var _col = __webpack_require__("G3dI");

var _col2 = _interopRequireDefault(_col);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

__webpack_require__("1szz");

__webpack_require__("Dp5J");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__("BYKG");

var _immutable2 = _interopRequireDefault(_immutable);

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _reactRedux = __webpack_require__("RH2O");

var _reactRouterDom = __webpack_require__("F8kA");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _doyle = __webpack_require__("Gr4k");

var _doyle2 = _interopRequireDefault(_doyle);

var _RecyclePage = __webpack_require__("hemH");

var _RecyclePage2 = _interopRequireDefault(_RecyclePage);

var _actionTypes = __webpack_require__("4HHy");

var _TrashAction = __webpack_require__("jBQT");

var _TrashNotesReducer = __webpack_require__("mXnL");

var _Message = __webpack_require__("mzOA");

var _Message2 = _interopRequireDefault(_Message);

var _EmptyContent = __webpack_require__("sCHe");

var _EmptyContent2 = _interopRequireDefault(_EmptyContent);

var _NestLoading = __webpack_require__("66rn");

var _NestLoading2 = _interopRequireDefault(_NestLoading);

var _VerifyModal = __webpack_require__("8wY1");

var _VerifyModal2 = _interopRequireDefault(_VerifyModal);

var _Icon = __webpack_require__("9JgI");

var _Icon2 = _interopRequireDefault(_Icon);

var _formatDate = __webpack_require__("3KG0");

var _formatDate2 = _interopRequireDefault(_formatDate);

var _urlHelper = __webpack_require__("kvZP");

var _util = __webpack_require__("oFuF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var doyle = new _doyle2.default();

var RecyclePage = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    trashNotesList: (0, _TrashNotesReducer.getTrashNotesListState)(state),
    trashNotes: (0, _TrashNotesReducer.getTrashNotesState)(state)
  };
}, function (dispatch) {
  return {
    getTrashNotesList: function getTrashNotesList() {
      return dispatch((0, _TrashAction.getTrashNotesList)());
    },
    getTrashNote: function getTrashNote(noteId) {
      return dispatch((0, _TrashAction.getTrashNote)(noteId));
    },
    delTrashNote: function delTrashNote(noteId, doneCallback) {
      return dispatch((0, _TrashAction.delTrashNote)(noteId, doneCallback));
    },
    recoveryTrashNote: function recoveryTrashNote(noteId, doneCallback) {
      return dispatch((0, _TrashAction.recoveryTrashNote)(noteId, doneCallback));
    }
  };
}), (0, _reactRouterDom.withRouter)(_class = _dec(_class = function (_Component) {
  (0, _inherits3.default)(RecyclePage, _Component);

  function RecyclePage(props) {
    (0, _classCallCheck3.default)(this, RecyclePage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RecyclePage.__proto__ || (0, _getPrototypeOf2.default)(RecyclePage)).call(this, props));

    _this.noteListItemOnMouseMove = function (e) {
      var spanElem = e.currentTarget.querySelector('span');
      spanElem.innerHTML = _reactIntlUniversal2.default.get('trash.del-time', { time: spanElem.getAttribute('data-destroy-date') });
    };

    _this.noteListItemOnMouseLeave = function (e) {
      var spanElem = e.currentTarget.querySelector('span');
      spanElem.innerHTML = _reactIntlUniversal2.default.get('trash.del-time2', { time: spanElem.getAttribute('data-destroy-days-left') });
    };

    _this.addDays = function (date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    };

    _this.renderNoteList = function (seq, entities) {
      var match = _this.props.match;
      var noteId = match.params.noteId;
      var maxDay = _this.state.maxDay;


      return seq.map(function (value, k) {
        var v = entities[value];
        var delAtDate = new Date(v.deleted_at * 1000);

        var timeLeft = maxDay - Math.floor((new Date() - delAtDate) / (3600 * 24 * 1000));
        var willDestroyDate = _this.addDays(new Date(v.deleted_at * 1000), 60);
        var itemClass = (0, _classnames2.default)((0, _defineProperty3.default)({}, _RecyclePage2.default['active'], v.id === +noteId));
        return _react2.default.createElement(
          'li',
          {
            key: k,
            className: itemClass,
            'data-noteid': k,
            onMouseMove: _this.noteListItemOnMouseMove,
            onMouseLeave: _this.noteListItemOnMouseLeave
          },
          _react2.default.createElement(
            _reactRouterDom.Link,
            { to: '/recycle/' + v.id, replace: true },
            _react2.default.createElement(
              'h5',
              null,
              _react2.default.createElement(_Icon2.default, { name: 'file-text', className: _RecyclePage2.default['icon-file-text'], fixedWidth: true }),
              v.title
            ),
            _react2.default.createElement(
              'span',
              {
                'data-destroy-days-left': timeLeft,
                'data-destroy-date': (0, _formatDate2.default)(willDestroyDate, 'yyyy-MM-dd')
              },
              timeLeft,
              ' \u5929\u540E\u6E05\u9664'
            )
          )
        );
      });
    };

    _this.onCloseBtnClick = function () {
      var history = _this.props.history;
      var _history$location$sta = history.location.state,
          state = _history$location$sta === undefined ? {} : _history$location$sta;

      if (state.canBack) {
        history.goBack();
      } else {
        history.push('/');
      }
    };

    _this.revertNote = function (noteId) {
      var history = _this.props.history;

      _this.props.recoveryTrashNote(noteId, function (error, data) {
        if (error) {
          _Message2.default.error(_reactIntlUniversal2.default.get('error.try-again'));
          return;
        }
        history.push((0, _urlHelper.getNormalPageUrl)(data.nbId, data.noteId));
      });
    };

    _this.delNote = function (noteId) {
      var _this$props = _this.props,
          trashNotesList = _this$props.trashNotesList,
          history = _this$props.history;

      var seq = trashNotesList.get('seq').toJS();
      var seqIndex = seq.indexOf(+noteId);
      _this.props.delTrashNote(noteId, function () {
        var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var data = arguments[1];

        if (error && error[0] && error[0].code === 9) {
          _this.setState({ verifyModalVisible: true });
          return;
        }
        // 成功跳转到下一篇
        if (!error) {
          history.push((0, _urlHelper.getRecyclePageUrl)(seq[seqIndex + 1] || seq[seqIndex - 1]));
        }
      });
    };

    _this.recoveryNoteBtnClick = function () {
      var _this$props2 = _this.props,
          match = _this$props2.match,
          history = _this$props2.history;
      var noteId = match.params.noteId;
      var isRecovering = _this.state.isRecovering;

      if (isRecovering) {
        return;
      }
      _this.revertNote(noteId);
    };

    _this.onModalCancelClick = function () {
      _this.setState({ verifyModalVisible: false });
    };

    _this.onModalConfirmBtnClick = function () {
      var match = _this.props.match;
      var noteId = match.params.noteId;

      _this.delNote(noteId);
      _this.onModalCancelClick();
    };

    _this.delNoteBtnClick = function () {
      var match = _this.props.match;
      var noteId = match.params.noteId;
      var isDeleting = _this.state.isDeleting;

      if (isDeleting) {
        return;
      }
      _this.delNote(noteId);
    };

    _this.getContentHTML = function () {
      var _this$props3 = _this.props,
          trashNotesList = _this$props3.trashNotesList,
          trashNotes = _this$props3.trashNotes,
          match = _this$props3.match;
      var noteId = match.params.noteId;

      var content = trashNotes.getIn([noteId, 'content']);
      var noteType = trashNotesList.getIn(['entities', noteId, 'note_type']);
      // 2 --> markdown
      if (noteType === 2) {
        return doyle.parse(content);
      }
      return content;
    };

    _this.state = {
      page: 'home',
      size: 'large',
      loading: false,
      maxDay: 60,
      listLoading: false,
      contentLoading: false,
      verifyModalVisible: false,
      isRecovering: false,
      isDeleting: false
    };
    _this.props.getTrashNotesList();
    return _this;
  }

  (0, _createClass3.default)(RecyclePage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var match = this.props.match;
      var noteId = match.params.noteId;
      // 刷新时如果有noteId，需要直接获取

      if (noteId) {
        this.props.getTrashNote(noteId);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var trashNotesList = nextProps.trashNotesList,
          trashNotes = nextProps.trashNotes,
          match = nextProps.match,
          history = nextProps.history;
      var noteId = match.params.noteId;
      var state = history.location.state; // 需要把state带过去

      var notelistSeq = trashNotesList.get('seq', _immutable2.default.fromJS([]));
      if (!noteId && notelistSeq.size > 0) {
        var hid = notelistSeq.get(0);
        history.replace('/recycle/' + hid, state);
      }
      var listStatus = trashNotesList.get('status');
      var listLoading = listStatus === _actionTypes.Trash.GET_TRASH_NOTES_LIST;
      var preNoteId = this.props.match.params.noteId;
      // 切换文章时
      if (preNoteId !== noteId && noteId) {
        nextProps.getTrashNote(noteId);
      }
      var contentStatus = trashNotes.getIn([noteId, 'status']);
      var isRecovering = contentStatus === _actionTypes.Trash.RECOVERY_TRASH_NOTE;
      var isDeleting = contentStatus === _actionTypes.Trash.DEL_TRASH_NOTE;
      var contentLoading = contentStatus === _actionTypes.Trash.GET_TRASH_NOTE_CONTENT;

      this.setState({
        listLoading: listLoading,
        isRecovering: isRecovering,
        contentLoading: contentLoading,
        isDeleting: isDeleting
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.noteWrapElem) {
        (0, _util.formatTheVideoPackage)(this.noteWrapElem);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          isDeleting = _state.isDeleting,
          listLoading = _state.listLoading,
          contentLoading = _state.contentLoading,
          isRecovering = _state.isRecovering,
          verifyModalVisible = _state.verifyModalVisible;
      var _props = this.props,
          trashNotesList = _props.trashNotesList,
          match = _props.match;
      var noteId = match.params.noteId;

      var notesListSeq = trashNotesList.get('seq', _immutable2.default.fromJS([]));
      var noteListSize = notesListSeq.size;
      var notesListEntities = trashNotesList.get('entities', _immutable2.default.fromJS({}));
      var title = notesListEntities.getIn([noteId, 'title'], '');
      var contentHTML = this.getContentHTML();
      return _react2.default.createElement(
        _row2.default,
        { className: _RecyclePage2.default['recycle-page'] },
        _react2.default.createElement(
          _col2.default,
          { className: _RecyclePage2.default['recycle-list-wrap'] },
          _react2.default.createElement(
            'div',
            { className: _RecyclePage2.default['title'] },
            _react2.default.createElement(_Icon2.default, { name: 'trash', className: _RecyclePage2.default['icon-trash'], fixedWidth: true }),
            _reactIntlUniversal2.default.get('trash.trash', { num: noteListSize })
          ),
          _react2.default.createElement(
            'ul',
            null,
            !!noteListSize && this.renderNoteList(notesListSeq.toJS(), notesListEntities.toJS()),
            _react2.default.createElement(_NestLoading2.default, { loading: listLoading })
          ),
          !noteListSize && _react2.default.createElement(_EmptyContent2.default, null)
        ),
        _react2.default.createElement(
          _col2.default,
          { className: _RecyclePage2.default['content-wrap'] },
          _react2.default.createElement(
            'div',
            { className: _RecyclePage2.default['title-wrap'] },
            _react2.default.createElement(
              'h3',
              null,
              title
            ),
            !isRecovering && _react2.default.createElement(
              'a',
              { onClick: this.onCloseBtnClick, className: _RecyclePage2.default['close'] },
              '\xD7'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: _RecyclePage2.default['content-view-wrap'] },
            contentHTML && _react2.default.createElement('div', {
              className: (0, _classnames2.default)('note-view', _RecyclePage2.default['content-view']),
              dangerouslySetInnerHTML: { __html: contentHTML },
              ref: function ref(v) {
                _this2.noteWrapElem = v;
              }
            }),
            !contentLoading && !contentHTML && _react2.default.createElement(_EmptyContent2.default, null),
            _react2.default.createElement(_NestLoading2.default, { loading: contentLoading })
          ),
          !contentLoading && _react2.default.createElement(
            'div',
            { className: _RecyclePage2.default['footer'] },
            _react2.default.createElement(
              'span',
              {
                className: (0, _classnames2.default)(_RecyclePage2.default['btn'], _RecyclePage2.default['btn-recovery']),
                onClick: this.recoveryNoteBtnClick
              },
              isRecovering ? _reactIntlUniversal2.default.get('trash.recovering') : _reactIntlUniversal2.default.get('trash.recovery')
            ),
            _react2.default.createElement(
              'span',
              {
                className: (0, _classnames2.default)(_RecyclePage2.default['btn'], _RecyclePage2.default['btn-del']),
                onClick: this.delNoteBtnClick
              },
              isDeleting ? _reactIntlUniversal2.default.get('trash.deleting') : _reactIntlUniversal2.default.get('trash.delete')
            )
          ),
          _react2.default.createElement(_VerifyModal2.default, {
            visible: verifyModalVisible,
            onModalCancelClick: this.onModalCancelClick,
            onModalConfirmBtnClick: this.onModalConfirmBtnClick
          })
        )
      );
    }
  }]);
  return RecyclePage;
}(_react.Component)) || _class) || _class);
exports.default = RecyclePage;

/***/ }),

/***/ "hemH":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("EAWY");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./RecyclePage.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./RecyclePage.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "jBQT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recoveryTrashNote = exports.delTrashNote = exports.getTrashNote = exports.getTrashNotesList = undefined;

var _actionTypes = __webpack_require__("4HHy");

var _createAction = __webpack_require__("lTDY");

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/prefer-default-export
/**
 * Created by zad on 17/4/25.
 */
var getTrashNotesList = exports.getTrashNotesList = (0, _createAction2.default)(_actionTypes.Trash.GET_TRASH_NOTES_LIST, 'isForce');

var getTrashNote = exports.getTrashNote = (0, _createAction2.default)(_actionTypes.Trash.GET_TRASH_NOTE_CONTENT, 'noteId');

var delTrashNote = exports.delTrashNote = (0, _createAction2.default)(_actionTypes.Trash.DEL_TRASH_NOTE, 'noteId', 'doneCallback');

// 恢复文章
var recoveryTrashNote = exports.recoveryTrashNote = (0, _createAction2.default)(_actionTypes.Trash.RECOVERY_TRASH_NOTE, 'noteId', 'doneCallback');

/***/ }),

/***/ "rzIX":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "._XPiX{background:hsla(0,0%,100%,.6)}._1Ksj7{font-size:14px}._1Ksj7 ._3slx8{color:#969696}._1Ksj7 .DsKt7{margin:20px 0 25px;text-align:center}._1Ksj7 .DsKt7 span{font-size:24px;margin:0 5px}._1Ksj7 ._267rA{position:relative;width:100%;margin-bottom:20px;font-size:15px;border:1px solid #c8c8c8;border-radius:4px;background-color:hsla(0,0%,97%,.1);padding:5px}body.reader-night-mode ._1Ksj7 ._267rA{border-color:#2e2e2e}._1Ksj7 ._267rA i{font-size:18px;display:inline-block;padding:5px;vertical-align:middle}._1Ksj7 ._267rA input{width:228px;background-color:transparent}._1Ksj7 ._267rA ._3Hq0E,._1Ksj7 ._267rA input{display:inline-block;line-height:36px;height:36px}._1Ksj7 ._267rA ._3Hq0E{width:100px;font-size:13px;text-align:center;color:#fff;background-color:#3194d0;border-radius:20px}._1Ksj7 .d3TYi{pointer-events:none;opacity:.5}._1Ksj7 .herXS{height:20px}._1Ksj7 ._3vO5f{width:100%;padding:9px 18px;font-size:18px;border:none;border-radius:25px;color:#fff;background-color:#3194d0;outline:none;display:block}._1Ksj7 ._1nasb,._1Ksj7 ._3vO5f{text-align:center;cursor:pointer}._1Ksj7 ._1nasb{font-size:14px;color:#3194d0;padding:20px 0 10px}", ""]);

// exports
exports.locals = {
	"mask": "_XPiX",
	"modal-body": "_1Ksj7",
	"des": "_3slx8",
	"chanel-des": "DsKt7",
	"input-prepend": "_267rA",
	"btn-in-resend": "_3Hq0E",
	"disable": "d3TYi",
	"tip": "herXS",
	"confirm-btn": "_3vO5f",
	"switch-btn": "_1nasb"
};

/***/ }),

/***/ "sCHe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _EmptyContent = __webpack_require__("AK2N");

var _EmptyContent2 = _interopRequireDefault(_EmptyContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmptyContent = function (_Component) {
  (0, _inherits3.default)(EmptyContent, _Component);

  function EmptyContent() {
    (0, _classCallCheck3.default)(this, EmptyContent);
    return (0, _possibleConstructorReturn3.default)(this, (EmptyContent.__proto__ || (0, _getPrototypeOf2.default)(EmptyContent)).apply(this, arguments));
  }

  (0, _createClass3.default)(EmptyContent, [{
    key: 'render',

    // eslint-disable-next-line class-methods-use-this
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _EmptyContent2.default['no-content'] },
        _react2.default.createElement(
          'span',
          null,
          _reactIntlUniversal2.default.get('app.name')
        )
      );
    }
  }]);
  return EmptyContent;
}(_react.Component);

exports.default = EmptyContent;

/***/ }),

/***/ "yqWn":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "._17D1C{position:relative;width:100%;height:100%;min-height:100px;min-width:100px;background-color:#f2f2f2;text-align:center}body.reader-night-mode ._17D1C{background-color:#3d3d3d}._17D1C span{display:block;font-size:64px;color:#e6e6e6;text-shadow:0 1px 0 #fff;position:absolute;top:50%;left:50%;margin-top:-48px;margin-left:-72px}body.reader-night-mode ._17D1C span{color:#4d4d4d;text-shadow:0 1px 0 #595959}", ""]);

// exports
exports.locals = {
	"no-content": "_17D1C"
};

/***/ })

});


// WEBPACK FOOTER //
// static/js/recycle.chunk.ecea3859b97a71f376cd.js